import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Hammer, LogOut, User, Shield, Building2 } from 'lucide-react';

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="sticky top-0 z-40 border-b border-[#E5E4E0] bg-[#FAF9F6]/85 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-6 py-4 md:px-10">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <span className="flex h-9 w-9 items-center justify-center bg-[#1A362D] text-white">
            <Hammer size={18} strokeWidth={2.2} />
          </span>
          <div className="leading-none">
            <div className="font-heading text-xl font-bold tracking-tight text-[#1C1B1A]">Trades &amp; Neighbours</div>
            <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#8A8988]">Property maintenance · Australia</div>
          </div>
        </Link>

        <nav className="hidden items-center gap-7 md:flex">
          <NavLink to="/search" data-testid="nav-search" className={({ isActive }) => `text-sm font-medium transition-colors hover:text-[#1A362D] ${isActive ? 'text-[#1A362D]' : 'text-[#5C5B5A]'}`}>Find a tradie</NavLink>
          <NavLink to="/passport" data-testid="nav-passport" className={({ isActive }) => `inline-flex items-center gap-1.5 text-sm font-medium transition-colors hover:text-[#D96C4E] ${isActive ? 'text-[#D96C4E]' : 'text-[#5C5B5A]'}`}>
            <Building2 size={14} /> Property Passport
          </NavLink>
          {user && user.role === 'tradie' && (
            <>
              <NavLink to="/tradie" data-testid="nav-tradie-dashboard" className={({ isActive }) => `text-sm font-medium transition-colors hover:text-[#1A362D] ${isActive ? 'text-[#1A362D]' : 'text-[#5C5B5A]'}`}>My work</NavLink>
              <NavLink to="/risk-trust" data-testid="nav-risk-trust" className={({ isActive }) => `inline-flex items-center gap-1.5 text-sm font-medium transition-colors hover:text-[#D96C4E] ${isActive ? 'text-[#D96C4E]' : 'text-[#5C5B5A]'}`}>
                <Shield size={14} /> Risk &amp; Trust
              </NavLink>
              <NavLink to="/portfolio/panel" data-testid="nav-tradie-panel" className={({ isActive }) => `text-sm font-medium transition-colors hover:text-[#1A362D] ${isActive ? 'text-[#1A362D]' : 'text-[#5C5B5A]'}`}>Panels</NavLink>
              <NavLink to="/compliance" data-testid="nav-compliance" className={({ isActive }) => `text-sm font-medium transition-colors hover:text-[#1A362D] ${isActive ? 'text-[#1A362D]' : 'text-[#5C5B5A]'}`}>Compliance</NavLink>
            </>
          )}
          {user && user.role === 'agent' && (
            <>
              <NavLink to="/portfolio" data-testid="nav-portfolio" className={({ isActive }) => `text-sm font-medium transition-colors hover:text-[#1A362D] ${isActive ? 'text-[#1A362D]' : 'text-[#5C5B5A]'}`}>Portfolio</NavLink>
              <NavLink to="/portfolio/panel" data-testid="nav-panel" className={({ isActive }) => `text-sm font-medium transition-colors hover:text-[#1A362D] ${isActive ? 'text-[#1A362D]' : 'text-[#5C5B5A]'}`}>Panel</NavLink>
              <NavLink to="/agency/pricing" data-testid="nav-agency-pricing" className={({ isActive }) => `text-sm font-medium transition-colors hover:text-[#1A362D] ${isActive ? 'text-[#1A362D]' : 'text-[#5C5B5A]'}`}>Plans</NavLink>
            </>
          )}
          {user && (user.role === 'consumer' || user.role === 'user') && (
            <NavLink to="/my-property" data-testid="nav-my-property" className={({ isActive }) => `text-sm font-medium transition-colors hover:text-[#1A362D] ${isActive ? 'text-[#1A362D]' : 'text-[#5C5B5A]'}`}>My Property</NavLink>
          )}
          {user && user.role === 'admin' && (
            <NavLink to="/admin" data-testid="nav-admin" className={({ isActive }) => `text-sm font-medium transition-colors hover:text-[#1A362D] ${isActive ? 'text-[#1A362D]' : 'text-[#5C5B5A]'}`}>Admin</NavLink>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <div className="hidden items-center gap-2 sm:flex">
                <div className="flex h-8 w-8 items-center justify-center rounded-full border border-[#E5E4E0] bg-white text-[#1A362D]">
                  <User size={16} />
                </div>
                <span className="text-sm font-medium text-[#1C1B1A]" data-testid="header-user-name">{user.name}</span>
              </div>
              <button onClick={doLogout} data-testid="logout-btn" className="btn-ghost">
                <LogOut size={16} />
                <span className="hidden sm:inline">Sign out</span>
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="header-login-btn" className="btn-ghost hidden sm:inline-flex">Sign in</Link>
              <Link to="/register" data-testid="header-register-btn" className="btn-primary">Get started</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
